module.exports = __webpack_public_path__ + "media/dashboard/assets/icons/ic_chat-43f231aab1e69f0655e31e2f09018d76.svg";